import { dateTimeMinuteFormatter, hourMinuteFormatter, weekdayShortFormatter } from '@dreryk/react-common';
import { Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';

type VisitDateProps = {
   readonly beginDate: Date;
   readonly endDate: Date;
};

export const VisitDate = (props: VisitDateProps): JSX.Element => {
   return (
      <TextSeparator as={'div'} separator={TextSeparatorType.SPACE}>
         <Text testId={'weekday'}>{weekdayShortFormatter(props.beginDate)}</Text>
         <Text testId={'date'}>
            {dateTimeMinuteFormatter(props.beginDate)}
            {props.beginDate !== props.endDate && `-${hourMinuteFormatter(props.endDate)}`}
         </Text>
      </TextSeparator>
   );
};
